import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { currentUser, roles, loading } = useAuth();

  if (loading) return null; // or a spinner

  if (!currentUser) return <Navigate to="/" replace />;

  const isAdmin = roles.includes("admin");
  if (!allowedRoles || allowedRoles.length === 0) return children;
  if (isAdmin) return children;

  const ok = roles.some(r => allowedRoles.includes(r));
  if (!ok) return <Navigate to="/dashboard" replace />;

  return children;
};

export default ProtectedRoute;
